import React from "react";
import * as styles from "./styles.module.scss";
import cx from "classname";
import { INLINES } from "@contentful/rich-text-types";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { openPopupWidget } from "react-calendly";

const isCalendlyLink = (url) =>
  url === "https://calendly.com/feelcove/connect-with-cove";
const openCalendly = (url) => (e) => {
  openPopupWidget({ url });
};

const wysiwygOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node) => {
      if (isCalendlyLink(node.data.uri)) {
        return (
          <button
            onClick={openCalendly(node.data.uri)}
            className={cx(styles.calendlyLink, "linkUnderline")}
          >
            {node.content[0].value}
          </button>
        );
      }
      return (
        <a href={node.data.uri} target="_blank" rel="noreferrer">
          {node.content[0].value}
        </a>
      );
    }
  }
};

function RichText({ value, className }) {
  if (!value) {
    return null;
  }
  return (
    <div className={styles.content}>
      <div className={className}>{renderRichText(value, wysiwygOptions)}</div>
    </div>
  );
}

export default RichText;
